import React from 'react';
import { Grid, GridRow, GridColumn } from 'semantic-ui-react';
import { SiteComponent } from 'Common/SiteComponent';

export const SitePicker = props => {
  return (
    <Grid>
      <GridRow>
        <GridColumn floated={'right'} width={6}>
          <SiteComponent onChange={props.onChange} disabled={props.disabled} />
        </GridColumn>
      </GridRow>
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/components/SitePicker.js